module.exports = __webpack_public_path__ + "static/media/crv2pool.e8789e80.png";